import $ from "jquery";

const equalCourseCardHeight = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        $(() => {
            const cards = document.querySelectorAll('.mi-courses__list-card');
            let maxHeight = 0;

            cards.forEach(card => {
                card.style.height = 'auto';
                const h = card.getBoundingClientRect().height;
                if (h > maxHeight) maxHeight = h;
            });

            cards.forEach(card => {
                card.style.height = (maxHeight - 44) + 'px';
            });
        });
    };

    init();
};

try {
    equalCourseCardHeight();
} catch (error) {
    console.error("equalCourseCardHeight", error);
}